export const DISLIKE_REASONS = [
  { code: "incorrect", label: "Incorrect" },
  { code: "citation_source_issue", label: "Citation/source issue" },
  { code: "irrelevant", label: "Irrelevant" },
  { code: "unclear", label: "Unclear" },
  { code: "too_long", label: "Too long" },
  { code: "potentially_unsafe", label: "Potentially unsafe" },
  { code: "other", label: "Other" },
] as const;

export type DislikeReasonCode = (typeof DISLIKE_REASONS)[number]["code"];
export type ChatReactionValue = "like" | "dislike";

export interface ChatReaction {
  reaction: ChatReactionValue;
  reason_codes: DislikeReasonCode[];
}

export const isDislikeReasonCode = (value: unknown): value is DislikeReasonCode =>
  typeof value === "string" &&
  DISLIKE_REASONS.some((reason) => reason.code === value);

export const normalizeChatReaction = (value: any): ChatReaction | null => {
  if (!value || (value.reaction !== "like" && value.reaction !== "dislike")) {
    return null;
  }
  return {
    reaction: value.reaction,
    reason_codes:
      value.reaction === "dislike" && Array.isArray(value.reason_codes)
        ? DISLIKE_REASONS.map((reason) => reason.code).filter((code) =>
            value.reason_codes.includes(code)
          )
        : [],
  };
};

